<template>
  <div>
    <v-text-field
      :id="idProp"
      class="password-input"
      v-model="formInput.$model"
      autocomplete="new-password"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      :color="color"
      :error-messages="errorMessages"
      :label="label || ($t && $t('L_password')) || 'Create a Password'"
      max-length="118"
      required
      @focus="onFocus"
      @update:model-value="(onInput($event), mask($event))"
      @blur="onBlur"
      @paste.prevent=""
      @copy.prevent=""
      @cut.prevent=""
      aria-describedby="password-tooltip password_hint"
      :type="masked ? 'password' : 'text'"
    >
      <template #append>
        <v-icon
          tabindex="0"
          :aria-label="$t('L_toggle_show_password')"
          class="toggle-masking"
          v-if="enableShowHide"
          @keydown="showPass($event)"
          @keyup="masked = true"
          @mouseenter="masked = false"
          @mouseleave="masked = true"
          @mousedown="masked = false"
          @mouseup="masked = true"
          :icon="masked ? mdiEye : mdiEyeOff"
        />
        <FieldIcon :form-field="formInput" :icon="validIcon" />
      </template>
    </v-text-field>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import FieldIcon from '@/components/FieldIcon/FieldIcon.vue';
import BaseTextField from '../BaseTextField.vue';
import { mdiEye, mdiEyeOff, mdiLockOutline } from '@mdi/js';

const componentOptions: ComponentOptions = {
  name: 'PasswordInput',
  extends: BaseTextField,
  components: { FieldIcon },
  data: () => ({
    modelName: 'password',
    password: '',
    maskTimeout: {} as Record<number, number | null>,
    mdiEye,
    mdiEyeOff,
  }),
  props: {
    idProp: {
      type: String,
      default: 'password',
    },
    validIcon: {
      type: String,
      default: mdiLockOutline,
    },
  },
  methods: {
    setInnerText(container: { innerText: string } | null, message: string) {
      if (container !== null) {
        container.innerText = message;
      }
    },
    mask(input: string) {
      const value = input;
      if (!this.masked) {
        this.textValue = value;
        this[this.modelName] = value;
        this.onInput(value);
        return;
      }
      const currentValue = this.textValue;
      const caretPosition = this.$el.querySelector('input').selectionStart;
      this[this.modelName] = value
        .split('')
        .map((char, i) => (char === currentValue[i] || i >= caretPosition ? '•' : char))
        .join('');

      this.textValue = value;
      if (this.maskTimeout[this._uid]) {
        window.clearTimeout(this.maskTimeout[this._uid]);
        this.maskTimeout[this._uid] = null;
      }
      this.maskTimeout[this._uid] = window.setTimeout(() => this.maskCallback(), 1200);
      this.onInput(this.formInput.$model);
    },
    showPass(e: KeyboardEvent) {
      if (e.keyCode >= 65 && e.keyCode <= 90) {
        this.masked = false;
      }
    },
  },
  mounted() {
    BaseTextField?.mounted?.bind(this)();
  },
};

export default defineComponent(componentOptions);
</script>
